import { render, staticRenderFns } from "./enrollChoose.vue?vue&type=template&id=88f6fc2c&scoped=true"
import script from "./enrollChoose.vue?vue&type=script&lang=js"
export * from "./enrollChoose.vue?vue&type=script&lang=js"
import style0 from "./enrollChoose.vue?vue&type=style&index=0&id=88f6fc2c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f6fc2c",
  null
  
)

export default component.exports